module.exports = __webpack_public_path__ + "img/avatar-p.f5d0724e.png";